import { FC, useState } from 'react'
import { IField } from 'types/ui/field.interface'
import {
  FieldWrapper,
  FieldLabel,
  FieldControl,
  FieldInput,
  FieldRight,
  FieldToggle,
  FieldHint,
  FieldError,
} from './Field.styled'

export const Field: FC<IField> = ({ id, label, error, hint, rightSlot, type, ...rest }) => {
  const [reveal, setReveal] = useState(false)
  const isPassword = type === 'password'
  const inputType = isPassword ? (reveal ? 'text' : 'password') : type

  return (
    <FieldWrapper>
      <FieldLabel htmlFor={id}>{label}</FieldLabel>
      <FieldControl>
        <FieldInput
          id={id}
          type={inputType}
          $hasError={!!error}
          $hasRight={isPassword || !!rightSlot}
          {...rest}
        />
        {isPassword ? (
          <FieldToggle type='button' onClick={() => setReveal((value) => !value)}>
            {reveal ? 'Hide' : 'Show'}
          </FieldToggle>
        ) : (
          rightSlot && <FieldRight>{rightSlot}</FieldRight>
        )}
      </FieldControl>
      {error ? <FieldError>{error}</FieldError> : hint ? <FieldHint>{hint}</FieldHint> : null}
    </FieldWrapper>
  )
}
